import React, { useEffect, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useDispatch, useSelector } from "react-redux";
import AddEditYearlyRpt from "../../../../../components/AddEditYearlyRpt";
import { formatAmount, getAllMonths, getAllYears } from "../../../../../services/appService";
import { getMonthlyClientInvoices, getQuartlyClientInvoices, loadMonthlyClientInvoices, loadQuartlyClientInvoices } from "../../../../store/reports";
import GeneratePdf from "../../../../../components/GeneratePdf";


const AgencyInvoiceBased = () => {

    const years = getAllYears();
    const months = getAllMonths();

    const [year, setYear] = useState("");
    const [month, setMonth] = useState("");
    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [rptShowHide, setRptShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState([]);
    const [selectedColData, setSelectedColData] = useState([]);
    const [clientRpt, setClientRpt] = useState([]);
    const [rptSelectedObj, setRptSelectedObj] = useState(null);
    const [rptType, setRptType] = useState("");

    const monthlyClientInvoicesSelector = useSelector(getMonthlyClientInvoices);
    const quartlyClientInvoicesSelector = useSelector(getQuartlyClientInvoices);

    const dispatch = useDispatch();

    const agencyGenerateRpt = () => {
        if (year && rptType === "m") dispatch(loadMonthlyClientInvoices(year));
        if (year && rptType === "q") dispatch(loadQuartlyClientInvoices(year));
    };

    useEffect(() => {
        setClientRpt(monthlyClientInvoicesSelector)
    }, [monthlyClientInvoicesSelector])

    useEffect(() => {
        setClientRpt(quartlyClientInvoicesSelector)
    }, [quartlyClientInvoicesSelector])

    const getClientRptTotal = () => {
        let prevDueT = 0;
        let yearT = 0;
        let paidT = 0;

        let Q1T = { invT: 0, recT: 0 };
        let Q2T = { invT: 0, recT: 0 };
        let Q3T = { invT: 0, recT: 0 };
        let Q4T = { invT: 0, recT: 0 };

        let monthT = months.map((m) => ({
            ...m,
            invT: 0,
            recT: 0
        }));

        clientRpt.forEach((item) => {
            prevDueT += parseFloat(item.previousDue) || 0;
            yearT += parseFloat(item.currentYearTotal) || 0;
            paidT += parseFloat(item.currentPaid) || 0;

            Q1T.invT += parseFloat(item.quarter1.invoiced) || 0;
            Q1T.recT += parseFloat(item.quarter1.received) || 0;

            Q2T.invT += parseFloat(item.quarter2.invoiced) || 0;
            Q2T.recT += parseFloat(item.quarter2.received) || 0;

            Q3T.invT += parseFloat(item.quarter3.invoiced) || 0;
            Q3T.recT += parseFloat(item.quarter3.received) || 0;

            Q4T.invT += parseFloat(item.quarter4.invoiced) || 0;
            Q4T.recT += parseFloat(item.quarter4.received) || 0;

            monthT.forEach((m) => {
                const key = m.name.toLowerCase();
                m.invT += parseFloat(item[key].invoiced) || 0;
                m.recT += parseFloat(item[key].received) || 0;
            });
        });

        return (
            <tr className="bg-lighter">
                <td className="font-weight-bold text-right" colSpan={3}>
                    Total
                </td>

                <td className="font-weight-bold text-right">
                    {formatAmount(prevDueT)}
                </td>

                {/* Monthly totals */}
                {rptType === "m" &&
                    monthT.map((m) => (
                        <td className="font-weight-bold text-right" key={m.name}>
                            {formatAmount(m.invT)} - {formatAmount(m.recT)}
                        </td>
                    ))}

                {/* Quarterly totals */}
                {rptType === "q" && (
                    <>
                        <td className="font-weight-bold text-right">
                            {formatAmount(Q1T.invT)} - {formatAmount(Q1T.recT)}
                        </td>
                        <td className="font-weight-bold text-right">
                            {formatAmount(Q2T.invT)} - {formatAmount(Q2T.recT)}
                        </td>
                        <td className="font-weight-bold text-right">
                            {formatAmount(Q3T.invT)} - {formatAmount(Q3T.recT)}
                        </td>
                        <td className="font-weight-bold text-right">
                            {formatAmount(Q4T.invT)} - {formatAmount(Q4T.recT)}
                        </td>
                    </>
                )}

                <td className="font-weight-bold text-right">
                    {formatAmount(yearT)}
                </td>

                <td className="font-weight-bold text-right">
                    {formatAmount(paidT)}
                </td>

                <td className="font-weight-bold text-right">
                    {formatAmount(yearT - paidT)}
                </td>

                <td></td>
            </tr>
        );
    };


    const agencyRptExportPdf = () => {

        const headers = [
            [
                "Candidate #",
                "Candidate",
                "Client",
                `${year - 1} Invoices Due in ${year}`,
            ],
        ];

        // Monthly headers
        if (rptType === "m") {
            months.forEach((m) => {
                headers[0].push(`${m.name} (Invoiced - Received)`);
            });
        }

        // Quarterly headers
        if (rptType === "q") {
            headers[0].push(`03/31/${year} 1st Quarter $ Invoiced - Received`);
            headers[0].push(`06/30/${year} 2nd Quarter $ Invoiced - Received`);
            headers[0].push(`09/30/${year} 3rd Quarter $ Invoiced - Received`);
            headers[0].push(`12/31/${year} 4th Quarter $ Invoiced - Received`);
        }

        headers[0].push(`${year} Year Total`);
        headers[0].push(`${year} Invoices Paid in ${year}`);
        headers[0].push(`${year} Invoices Paid in ${year + 1}`);

        const colData = [];

        clientRpt.forEach((item) => {
            const dt = [];

            dt.push(
                item.candidateId,
                `${item.candidate}`, // candidate name
                item.clientName,
                formatAmount(item.previousDue)          // previous year due
            );

            // MONTHLY values
            if (rptType === "m") {
                months.forEach((m) => {
                    const key = m.name.toLowerCase();
                    dt.push(
                        `${formatAmount(item[key].invoiced)} - ${formatAmount(item[key].received)}`
                    );
                });
            }

            // QUARTERLY values
            if (rptType === "q") {
                dt.push(`${formatAmount(item.quarter1.invoiced)} - ${formatAmount(item.quarter1.received)}`);
                dt.push(`${formatAmount(item.quarter2.invoiced)} - ${formatAmount(item.quarter2.received)}`);
                dt.push(`${formatAmount(item.quarter3.invoiced)} - ${formatAmount(item.quarter3.received)}`);
                dt.push(`${formatAmount(item.quarter4.invoiced)} - ${formatAmount(item.quarter4.received)}`);
            }

            // YEAR totals
            dt.push(formatAmount(item.currentYearTotal));
            dt.push(formatAmount(item.currentPaid));
            dt.push(formatAmount(item.currentYearTotal - item.currentPaid));

            colData.push(dt);
        });

        setSelectedCol(headers);
        setSelectedColData(colData);
        setPdfShowHide(true);
    };


    const handlepdfShowHide = () => {
        setPdfShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };


    const handlePreviousDue = ({ currentTarget }) => {
        const newClientReport = [...clientRpt];
        const id = currentTarget.name.split("_")[1];
        const index = newClientReport.findIndex((x) => x.candidateId == id);
        const currentObj = { ...newClientReport[index] };
        currentObj.previousDue = parseFloat(currentTarget.value);
        if (currentTarget.value !== "") {
            currentObj.currentYearTotal = currentObj.yearTotal + currentObj.previousDue;
            currentObj.nextDue = currentObj.currentYearTotal - currentObj.currentPaid;
        }
        newClientReport[index] = currentObj;
        setClientRpt(newClientReport);
    };

    const handleCurrenYearPaid = ({ currentTarget }) => {
        const newClientReport = [...clientRpt];
        const id = currentTarget.name.split("_")[1];
        const index = newClientReport.findIndex((x) => x.candidateId === id);
        const currentObj = { ...newClientReport[index] };
        currentObj.currentPaid = parseFloat(currentTarget.value);
        if (currentTarget.value !== "") {
            currentObj.currentDue = currentObj.currentYearTotal - currentObj.currentPaid;
            currentObj.nextDue = currentObj.currentDue;
        }
        newClientReport[index] = currentObj;
        setClientRpt(newClientReport);
    };

    const handleSaveCandidateRpt = async (item) => {
        setRptSelectedObj(item);
        setRptShowHide(true);
    };

    const handleRptShowHide = (type) => {
        setRptShowHide(false);
        setRptSelectedObj(null);
        if (type === "save")
            agencyGenerateRpt();
    };

    const handleRptTypeChange = ({ currentTarget }) => {
        setRptType(currentTarget.value);
        setClientRpt([]);
    }


    return <>
        <div className="card shadow-none border">
            <div className="card-header text-center p-3 bg-lighter">
                <h4 className="mb-0">
                    Invoices Raised to Clients - Accrual Basis
                </h4>
            </div>
            <div className="card-body p-3">
                <div className="row">
                    <div className="col-md-2">
                        <select
                            name="rptType"
                            id="rptType"
                            className="form-control form-control-sm"
                            onChange={handleRptTypeChange}
                            value={rptType}
                        >
                            <option value="">Select Type</option>
                            <option value="m">Monthly</option>
                            <option value="q">Quarterly</option>
                        </select>
                    </div>
                    <div className="col-md-3">
                        <select
                            name="year"
                            id="year"
                            className="form-control form-control-sm"
                            onChange={({ currentTarget }) => setYear(parseInt(currentTarget.value))}
                            value={year}
                        >
                            <option value="">Year</option>
                            {years.map((y) => (
                                <option value={y.name}>{y.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <button
                            className="btn btn-sm btn-outline-default"
                            disabled={!year}
                            onClick={agencyGenerateRpt}
                        >
                            Generate
                        </button>
                    </div>
                    <div className="col-md-3 text-right">
                        <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="btn btn-sm btn-outline-default"
                            table="mon_client_inv"
                            filename="Client_Invoice_Monthly"
                            sheet="Client_Invoice_Monthly"
                            buttonText="Export Excel"
                        />
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-default"
                            disabled={clientRpt.length === 0}
                            onClick={agencyRptExportPdf}
                        >
                            Export PDF
                        </button>
                    </div>
                    <div className="col-md-12 mt-2">
                        <div className="table-responsive">
                            <table
                                className="table align-items-center table-flush table-hover table-striped mb-2 border"
                                id="mon_client_inv"
                            >
                                <thead className="thead-light">
                                    <th>Candidate #</th>
                                    <th>Candidate</th>
                                    <th>Client</th>
                                    <th>
                                        {year - 1} Invoices
                                        <br />
                                        Due in {year}
                                    </th>
                                    {rptType === "m" && months.map((m) => (
                                        <th>
                                            {m.name} $
                                            <br />
                                            (Invoiced - Received)
                                        </th>
                                    ))}
                                    {rptType === "q" && <>

                                        <th>
                                            03/31/{year} 1st Quarter $
                                            <br />
                                            Invoiced - Received
                                        </th>
                                        <th>
                                            06/30/{year} 2nd Quarter $
                                            <br />
                                            Invoiced - Received
                                        </th>
                                        <th>
                                            09/30/{year} 3rd Quarter $
                                            <br />
                                            Invoiced - Received
                                        </th>
                                        <th>
                                            12/31/{year} 4th Quarter $
                                            <br />
                                            Invoiced - Received
                                        </th>
                                    </>}
                                    <th>
                                        {year} Year Total $
                                    </th>
                                    <th>
                                        {year} Invoices $
                                        <br />
                                        Paid in {year}
                                    </th>
                                    <th>
                                        {year} Invoices $
                                        <br />
                                        Paid in {year + 1}
                                    </th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    {clientRpt.map((item) => (
                                        <tr>
                                            <td>{item.candidateId}</td>

                                            <td>{item.candidate} {item.candidateLastName}</td>

                                            <td>{item.clientName}</td>

                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm text-right"
                                                    onChange={handlePreviousDue}
                                                    id={`prev_${item.candidateId}`}
                                                    name={`prev_${item.candidateId}`}
                                                    value={formatAmount(item.previousDue)}
                                                />
                                            </td>

                                            {/* ==== MONTHLY REPORT ==== */}
                                            {rptType === "m" &&
                                                months.map((m) => (
                                                    <td className="text-right">
                                                        {`${formatAmount(
                                                            item[m.name.toLowerCase()].invoiced
                                                        )} - ${formatAmount(
                                                            item[m.name.toLowerCase()].received
                                                        )}`}
                                                    </td>
                                                ))}

                                            {/* ==== QUARTERLY REPORT ==== */}
                                            {rptType === "q" && (
                                                <>
                                                    <td className="text-right">
                                                        {`${formatAmount(item.quarter1.invoiced)} - ${formatAmount(item.quarter1.received)}`}
                                                    </td>
                                                    <td className="text-right">
                                                        {`${formatAmount(item.quarter2.invoiced)} - ${formatAmount(item.quarter2.received)}`}
                                                    </td>
                                                    <td className="text-right">
                                                        {`${formatAmount(item.quarter3.invoiced)} - ${formatAmount(item.quarter3.received)}`}
                                                    </td>
                                                    <td className="text-right">
                                                        {`${formatAmount(item.quarter4.invoiced)} - ${formatAmount(item.quarter4.received)}`}
                                                    </td>
                                                </>
                                            )}

                                            <td className="text-right">
                                                {formatAmount(item.currentYearTotal)}
                                            </td>

                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm text-right"
                                                    onChange={handleCurrenYearPaid}
                                                    id={`curr_${item.candidateId}`}
                                                    name={`curr_${item.candidateId}`}
                                                    value={formatAmount(item.currentPaid)}
                                                />
                                            </td>

                                            <td className="text-right">
                                                {formatAmount(item.currentYearTotal - item.currentPaid)}
                                            </td>

                                            <td>
                                                <button
                                                    className="btn btn-outline-default btn-sm"
                                                    onClick={() => handleSaveCandidateRpt(item)}
                                                >
                                                    Save
                                                </button>
                                            </td>
                                        </tr>
                                    ))}

                                    {getClientRptTotal()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AddEditYearlyRpt
            rptShowHide={rptShowHide}
            handleRptShowHide={handleRptShowHide}
            selectedObj={rptSelectedObj}
            year={year}
        ></AddEditYearlyRpt>
        <GeneratePdf
            handlepdfShowHide={handlepdfShowHide}
            pdfShowHide={pdfShowHide}
            selectedCol={selectedCol}
            selectedColData={selectedColData}
        ></GeneratePdf>
    </>
}

export default AgencyInvoiceBased;